<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  lead: { type: Object, required: true },
});

const router = useRouter();
const accountId = useMapGetter('getCurrentAccountId');

const temperatureClass = computed(() => {
  const t = (props.lead.temperatura || '').toLowerCase();
  if (t === 'quente') return 'text-red-500';
  if (t === 'morno') return 'text-yellow-500';
  return 'text-n-slate-11';
});

const openConversation = () => {
  if (!props.lead.conversation_id) return;
  router.push({
    name: 'inbox_conversation',
    params: {
      accountId: accountId.value,
      conversation_id: props.lead.conversation_id,
    },
  });
};
</script>

<template>
  <div
    class="rounded-2xl border border-n-weak bg-n-alpha-1 p-4 flex flex-col gap-3"
  >
    <!-- Header: nome + temperatura + abrir conversa -->
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ lead.nome || 'Lead sem nome' }}
        </h3>
        <span
          v-if="lead.temperatura"
          class="text-xs font-medium"
          :class="temperatureClass"
        >
          {{ lead.temperatura }}
        </span>
      </div>
      <button
        v-if="lead.conversation_id"
        class="inline-flex items-center gap-1 text-xs text-n-brand hover:underline"
        @click="openConversation"
      >
        <svg
          class="h-3.5 w-3.5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
          />
        </svg>
        Abrir conversa
      </button>
    </div>

    <!-- Oferece / Busca -->
    <div class="flex flex-col gap-1.5">
      <p class="text-xs text-n-slate-11">
        <span class="font-semibold text-n-slate-12">Oferece:</span>
        {{ lead.oferece || '—' }}
      </p>
      <p class="text-xs text-n-slate-11">
        <span class="font-semibold text-n-slate-12">Busca:</span>
        {{ lead.busca || '—' }}
      </p>
    </div>
  </div>
</template>
